import React, { useContext } from 'react';
import styled from 'styled-components';
import HeaderContext from '../../HeaderContext';
import { NavLink } from '../../search/style';
import { GA_CATEGORY } from '../constants';
import HoverMenu from '../hover-menu';
import CategoryDropdown from './category-dropdown';
import data from './data.json';
import Dropdown from './dropdown';

const SpecialFix = styled.span<{ hasSearch?: boolean }>`
  @media screen and (max-width: ${props => (props.hasSearch ? `1440px` : `960px`)}) {
    display: none;
  }
`;

//nav list for desktop
export const DesktopNav = styled.ul`
  margin-bottom: 0;
  margin-top: 0;
  text-align: left;
  display: inline-block;
  padding: 16px 0;
  vertical-align: top;
`;

//use same stlying for mobile and desktop nav links

const HeaderLinks: React.FC = () => {
  const { siteSource, hasSearch } = useContext(HeaderContext);
  return (
    <DesktopNav data-label={'header-links'}>
      <HoverMenu
        pointOffset="85px" /* where the pointy bit on top of hover menu should be positioned */
        menuItem={
          <NavLink
            href="/find"
            data-ga-category={GA_CATEGORY}
            data-ga-action={`${GA_CATEGORY} - Clicked Trade Categories`}
            data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
            data-ga-hover-action={`${GA_CATEGORY} - Hover Trade Categories`}
          >
            Directory
          </NavLink>
        }
      >
        <CategoryDropdown categories={data.categories} popularCategories={data.popularCategories} />
      </HoverMenu>
      <HoverMenu
        pointOffset="88px"
        menuItem={
          <NavLink
            href="/articles"
            data-ga-category={GA_CATEGORY}
            data-ga-action={`${GA_CATEGORY} - Clicked Articles`}
            data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
            data-ga-hover-action={`${GA_CATEGORY} - Hover Articles`}
          >
            Articles
          </NavLink>
        }
      >
        <Dropdown
          items={data.articleCategories}
          footer={{
            key: '/articles',
            value: 'View all article topics',
            desc: 'Article',
          }}
          sourceType="Topics"
        />
      </HoverMenu>
      <HoverMenu
        pointOffset="103px"
        menuItem={
          <NavLink
            href="/c/cost"
            data-ga-category={GA_CATEGORY}
            data-ga-action={`${GA_CATEGORY} - Clicked Cost Guides`}
            data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
            data-ga-hover-action={`${GA_CATEGORY} - Hover Cost Guides`}
          >
            Cost Guides
          </NavLink>
        }
      >
        <Dropdown
          items={data.costGuides}
          footer={{
            key: '/articles',
            value: 'View all cost guides',
            desc: 'Cost Guide',
          }}
          sourceType="Cost Guides"
        />
      </HoverMenu>
      {!hasSearch && (
        <SpecialFix>
          <NavLink
            href="/homes/"
            title="Homes"
            data-ga-category={GA_CATEGORY}
            data-ga-action={`${GA_CATEGORY} - Clicked My Toolbox - Homes`}
            data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
          >
            Homes
          </NavLink>
        </SpecialFix>
      )}
    </DesktopNav>
  );
};

export default HeaderLinks;
